import { useContext } from 'react';
import * as React from 'react';
import { PostPurchaseContext } from '@/features/editor/widgets/post-purchase/context';
import {
  DropdownInput,
  DropdownInputOption,
} from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { InputsDarkTheme } from '@/features/editor/widgets/custom-widget/inputs/shared/input-type';

export function PostPurchaseOfferCount() {
  const {
    props: {
      settings: { offersCount, layout },
    },
    setProps,
  } = useContext(PostPurchaseContext);

  const isGrid = layout === `grid`;
  const maxOffers = isGrid ? 4 : 3;

  const options: DropdownInputOption[] = [
    { label: `1 Offer`, value: 1 },
    { label: `2 Offers`, value: 2 },
    { label: `3 Offers`, value: 3 },
    ...(isGrid ? [{ label: `4 Offers`, value: 4 }] : []),
  ];

  const clampedCount = Math.min(offersCount, maxOffers);

  const onChange = (val: DropdownInputOption) => {
    setProps((draft) => {
      draft.settings.offersCount = val.value as number;
    });
  };

  return (
    <DropdownInput
      key={`${clampedCount}-${maxOffers}`}
      theme={InputsDarkTheme}
      options={options}
      defaultValue={options[clampedCount - 1]}
      onChange={onChange}
      optionStyles={{ textTransform: `uppercase` }}
    />
  );
}
